// Canonical production origin. Used instead of window.location for SEO tags
// and structured data so prerendered HTML never bakes in a local/staging host.
export const SITE_ORIGIN = "https://www.createprints.ai";

export function canonicalUrl(pathname) {
  const path = pathname ?? window.location.pathname;
  const normalized = path !== "/" && path.endsWith("/") ? path.slice(0, -1) : path;
  return `${SITE_ORIGIN}${normalized}`;
}
